<style lang='scss' scoped>
.sysorg {
	cursor: pointer;
	outline:none !important;
	&:hover {
		color: #4093ff;
		background-color: #09659A;
	}
}
.sysorg-avatar {
	border-radius: 9999px;
	width: 29px;
	height: 29px;
	margin-right: 5px;
}
.sysorg-title{
	max-width: 100px;
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
}
</style>


<template>
	<aside
		class="sysorg"
		tabindex='-1'
		v-show="organization.name"
		@click="open"
		@focusout="handleFocusOut"
	>
		<img src="../../../../image/sys.png" class="sysorg-avatar" />
		<span :title="organization.name" class="sysorg-title">{{organization.name}}&nbsp;</span>
		<transition appear name="move-up">
			<compSysList v-show="visible" />
		</transition>
	</aside>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import compSysList from './syslist';

export default {
	components: {
		compSysList
	},
	data() {
		return {
			visible: false
		};
	},
	methods: {
		handleFocusOut(){
			console.log(document.activeElement)
			clearTimeout(this.__timeout);
			this.__timeout = setTimeout(() => {
				if(!this.$el.contains(document.activeElement)) this.visible = false
			}, 400)
		},
		open() {
			clearTimeout(this.__timeout);
			this.visible = !this.visible;
		},
	},
	computed: {
		...mapState(['organization']),
	}
};
</script>
